import { map } from 'rxjs';
import { fromUnixTime } from 'date-fns';
import { ADMIN_API } from '../AdminAPI';
import { convertUnixToDate } from '@golden/utils';
export function createEmperorService(api) {
    return {
        getLayer(id) {
            return api.fetch(ADMIN_API.GET_LAYER, { config: { urlParams: { id } } });
        },
        getLayerInfo(id) {
            return api.fetch(ADMIN_API.GET_LAYER_INFO, { config: { urlParams: { id } } }).pipe(map((res) => convertUnixToDate(res, 'created_at')));
        },
        getLayerInfoChildren(id, data) {
            return api.fetch(ADMIN_API.GET_LAYER_INFO_CHILDREN, { config: { urlParams: { id } }, data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
            })));
        },
        getSuggestAccount() {
            return api.fetch(ADMIN_API.GET_SUGGEST_ACCOUNT);
        },
        getEmperorList(data) {
            return api.fetch(ADMIN_API.GET_EMPEROR_LIST, { data })
                .pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => ({
                    ...item,
                    created_at: fromUnixTime(item.created_at)
                }))
            })));
        },
        getEmperorFees() {
            return api.fetch(ADMIN_API.GET_EMPEROR_FEES);
        },
        createEmperor(data) {
            return api.fetch(ADMIN_API.POST_NEW_EMPEROR, { data });
        },
        getEmperor(id) {
            return api.fetch(ADMIN_API.GET_EMPEROR, { config: { urlParams: { id } } });
        },
        updateEmperor(data, id) {
            return api.fetch(ADMIN_API.PUT_CHANGE_EMPEROR, { data, config: { urlParams: { id } } });
        },
        updateAgent(id, isLoginable, memo) {
            return api.fetch(ADMIN_API.PUT_AGENT, { data: { is_loginable: isLoginable, memo }, config: { urlParams: { id } } });
        },
        getStaffList() {
            return api.fetch(ADMIN_API.GET_STAFF_LIST);
        }
    };
}
//# sourceMappingURL=EmperorService.js.map